import { useElementShown } from '@hh.ru/analytics-js';
import vacancyButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/vacancy_button_click';
import vacancyElementShown from '@hh.ru/analytics-js-events/build/career_platform/profession/vacancy_element_shown';
import { translation, format, TranslatedComponent } from '@hh.ru/front-static-app';
import { Card, Text, Title } from '@hh.ru/magritte-ui';

import { ProfessionTopVacancy } from 'src/models/pages/profession';
import { GradeId } from 'src/types/grade';
import { ProfessionId } from 'src/types/profession';
import { analytics, Goal } from 'src/utils/analytics';
import { getCurrency } from 'src/utils/currency';

import styles from './styles.less';

const TrlKeys = {
    cardName: 'career-platform.profession.sections.statistic.vacancies.card.name',
    salary: 'career-platform.profession.sections.statistic.vacancies.card.salary',
};

interface Props extends ProfessionTopVacancy {
    professionId: ProfessionId;
    gradeId: GradeId;
}

const VacanciesItem: TranslatedComponent<Props> = ({
    trls,
    name,
    salaryFrom,
    currency,
    region,
    employerName,
    redirect,
    professionId,
    gradeId,
}) => {
    const elementRef = useElementShown(vacancyElementShown, {
        professionId,
        levelId: gradeId,
    });

    const handleClick = () => {
        analytics.reach(Goal.click_vacancy);
        vacancyButtonClick({
            professionId,
            levelId: gradeId,
        });
    };

    return (
        <Card
            actionCard
            borderRadius={24}
            padding={24}
            showBorder
            onClick={handleClick}
            Element="a"
            href={redirect.link}
            target="_blank"
            rel="noreferrer noopener nofollow"
            ref={elementRef}
        >
            <div className={styles.vacanciesCardContent}>
                <Text typography="label-3-regular" style="secondary" Element="p">
                    {trls[TrlKeys.cardName]}
                </Text>
                <div className={styles.vacanciesCardName}>
                    <Title size="medium" Element="h3" maxLines={2}>
                        {name}
                    </Title>
                </div>
                {salaryFrom && currency && (
                    <Title size="small" Element="h4">
                        {format(trls[TrlKeys.salary], { '{0}': getCurrency(salaryFrom, currency) })}
                    </Title>
                )}
                <div className={styles.vacanciesCardCompany}>
                    <Text typography="label-2-regular" Element="p">
                        {employerName}
                    </Text>
                </div>
                <Text typography="label-2-regular" Element="p">
                    {region}
                </Text>
            </div>
        </Card>
    );
};

export default translation(VacanciesItem);
